import React, {Component} from 'react'
import HamburgerMenu from 'react-hamburger-menu';
import Link from 'gatsby-link'
import styled from 'styled-components';
import logo from '../../assets/img/logo.svg'
import DesktopMenu from "./DesktopMenu";
import {MobileDropdown} from "../Dropdown/Dropdown";

const Nav = styled.nav`
  position: fixed;
  width: 100%;
  background: #fff;
  z-index: 11;
  top: 0;
  height: 60px;
  border-bottom: 1px solid #e3e3e3;
  
  @media (min-width: 768px) {
    height: 75px;
  }
  
  @media (min-width: 992px) {
    height: 85px;
  }
  
  @media (min-width: 1200px) {
    height: 95px;
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px 10px;
  
  .hamburger {
    cursor: pointer;
  }
  
  @media(min-width: 768px){
      .hamburger{
        display: none;
      }

      padding: 10px;

`;

const Logo = styled.img`
  width: 90px;
  height: auto;
  
  @media (min-width: 768px) {
    width: 100px;
  }
  
  @media(min-width: 992px) {
    width: 130px;
  }
  
  @media(min-width: 1200px) {
    width: 150px;
  }
`;

const MenuItems = [
    {title: 'Get to Know H & N', link: '/get-to-know', titleseo:"Get to Know H & N Group"},
    {title: 'Product Info', link: '/product-info', titleseo:"H & N Group Wholesale Products"},
    {title: 'Affiliations', link: '/affiliations', titleseo:"H & N Group Affiliates"},
    {title: 'Connect', link: '/connect', titleseo:"Get In Touch with H & N Group"},
];

class NavBar extends Component {
    state = {
        isOpen: false
    };

    handleClick = () => {
        this.setState({isOpen: !this.state.isOpen})
    };

    render() {
        const {isOpen} = this.state;
        const {slug, jobOpening} = this.props;
        return (
          <Nav>
              <Container>
                  <Link to="/" title="H & N Group"><Logo src={logo}/></Link>
                  <div className="hamburger">
                      <HamburgerMenu
                        isOpen={isOpen}
                        menuClicked={this.handleClick}
                        width={20}
                        height={16}
                        strokeWidth={3}
                        color="#255e94"
                      />
                  </div>
                  <DesktopMenu
                    slug={slug}
                    jobOpening={jobOpening}
                  />
              </Container>
              <MobileDropdown isOpen={isOpen}>
                  {MenuItems.map((i) => {
                      return <Link key={i.link} to={i.link} title={i.titleseo} onClick={() => this.handleClick()}>{i.title}</Link>
                  })}
              </MobileDropdown>
          </Nav>

        );
    }
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js